<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="状态">
                <a-select v-model="queryParam.status" placeholder="全部" allow-clear style="width: 100%">
                  <a-select-option :value="1">待审核</a-select-option>
                  <a-select-option :value="2">处理中</a-select-option>
                  <a-select-option :value="3">已打款</a-select-option>
                  <a-select-option :value="4">驳回</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="openPhraseManage"><a-icon type="setting" />驳回话术</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table :loading="loading" rowKey="id" :columns="columns" :data-source="list" :pagination="false" :scroll="{ x: 1780 }">
        <span slot="status" slot-scope="text">
          <a-tag v-if="text === 1" color="orange">待审核</a-tag>
          <a-tag v-else-if="text === 2" color="blue">处理中</a-tag>
          <a-tag v-else-if="text === 3" color="green">已打款</a-tag>
          <a-tag v-else-if="text === 4" color="red">驳回</a-tag>
        </span>
        <span slot="userTotalAmount" slot-scope="text">
          <span class="amount-cell total">{{ formatMoney(text) }}</span>
        </span>
        <span slot="walletBalanceBefore" slot-scope="text">
          <span class="amount-cell wallet">{{ formatMoney(text) }}</span>
        </span>
        <span slot="amount" slot-scope="text">
          <span class="amount-cell withdraw">{{ formatMoney(text) }}</span>
        </span>
        <span slot="balanceAfterWithdraw" slot-scope="text">
          <span class="amount-cell after">{{ formatMoney(text) }}</span>
        </span>
        <span slot="feeAmount" slot-scope="text">
          <span class="amount-cell fee">{{ formatMoney(text) }}</span>
        </span>
        <span slot="actualAmount" slot-scope="text">
          <span class="amount-cell actual">{{ formatMoney(text) }}</span>
        </span>
        <span slot="bankInfo" slot-scope="text, record">
          <div>{{ record.bankName || '—' }}</div>
          <div class="sub-text">{{ record.accountName || '—' }}</div>
          <div class="sub-text">{{ record.cardNo || '—' }}</div>
          <a class="copy-link" @click.stop="copyBankInfo(record)">
            <a-icon type="copy" /> 复制收款信息
          </a>
        </span>
        <span slot="paymentProofUrl" slot-scope="text">
          <oss-img v-if="text" :src="text" class="thumb-img clickable" />
        </span>
        <span slot="operation" slot-scope="text, record">
          <a v-if="needsClaim(record)" @click="claimOrder(record)">接单</a>
          <template v-else-if="canAuditActions(record) && record.status === 1">
            <a @click="showDetail(record)">详情</a>
            <a-divider type="vertical" />
            <a @click="audit(record, 2)">审核通过</a>
            <a-divider type="vertical" />
            <a @click="showReject(record)">驳回</a>
          </template>
          <template v-else-if="canAuditActions(record) && record.status === 2">
            <a @click="showDetail(record)">详情</a>
            <a-divider type="vertical" />
            <a @click="showPay(record)">确认打款</a>
            <a-divider type="vertical" />
            <a @click="showReject(record)">驳回</a>
          </template>
          <a v-else-if="!isProcessable(record)" @click="showDetail(record)">详情</a>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        @change="changePage"
      />
    </a-card>

    <a-modal title="提现详情" :visible="detailOpen" :footer="null" width="560px" @cancel="detailOpen = false">
      <a-spin :spinning="detailLoading">
        <template v-if="detail">
          <a-descriptions bordered size="small" :column="1">
            <a-descriptions-item label="提现单号">{{ detail.withdrawNo }}</a-descriptions-item>
            <a-descriptions-item label="用户ID">{{ detail.userId }}</a-descriptions-item>
            <a-descriptions-item label="收款银行">
              {{ detail.bankName || '—' }}
              <a class="copy-link inline-copy" @click="copyBankInfo(detail)">
                <a-icon type="copy" /> 复制
              </a>
            </a-descriptions-item>
            <a-descriptions-item label="开户名">{{ detail.accountName || '—' }}</a-descriptions-item>
            <a-descriptions-item label="银行卡号">{{ detail.cardNo || '—' }}</a-descriptions-item>
            <a-descriptions-item label="用户总额">
              <span class="amount-cell total">{{ formatMoney(detail.userTotalAmount) }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="钱包金额">
              <span class="amount-cell wallet">{{ formatMoney(detail.walletBalanceBefore) }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="本次提现">
              <span class="amount-cell withdraw">{{ formatMoney(detail.amount) }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="提现成功余额">
              <span class="amount-cell after">{{ formatMoney(detail.balanceAfterWithdraw) }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="手续费">{{ formatMoney(detail.feeAmount) }}</a-descriptions-item>
            <a-descriptions-item label="实到金额">{{ formatMoney(detail.actualAmount) }}</a-descriptions-item>
            <a-descriptions-item label="状态">{{ statusText(detail.status) }}</a-descriptions-item>
            <a-descriptions-item v-if="detail.rejectReason" label="驳回原因">{{ detail.rejectReason }}</a-descriptions-item>
            <a-descriptions-item v-if="splitImageUrls(detail.rejectImageUrls).length" label="驳回图片">
              <div class="img-row">
                <img
                  v-for="(img, i) in splitImageUrls(detail.rejectImageUrls)"
                  :key="'wd-' + i"
                  v-image-preview
                  :src="img"
                  class="thumb-img clickable"
                />
              </div>
            </a-descriptions-item>
            <a-descriptions-item v-if="detail.paymentProofUrl" label="打款凭证">
              <img v-image-preview :src="detail.paymentProofUrl" class="thumb-img clickable" />
            </a-descriptions-item>
            <a-descriptions-item label="申请时间">{{ detail.createTime }}</a-descriptions-item>
          </a-descriptions>
        </template>
      </a-spin>
    </a-modal>

    <a-modal title="驳回提现" :visible="rejectOpen" :confirm-loading="rejectSubmitting" @ok="submitReject" @cancel="closeReject">
      <a-spin :spinning="phraseLoading">
        <a-form-model layout="vertical">
          <a-form-model-item label="选择话术">
            <a-radio-group v-model="selectedPhraseKey">
              <div v-for="item in rejectPhrases" :key="item.id" class="phrase-radio">
                <a-radio :value="'p-' + item.id">{{ item.title }}</a-radio>
              </div>
              <div class="phrase-radio">
                <a-radio value="custom">自定义</a-radio>
              </div>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="驳回原因（可编辑）" required>
            <a-textarea v-model="rejectReason" placeholder="请选择话术或输入自定义驳回原因" :rows="4" />
          </a-form-model-item>
          <a-form-model-item label="驳回图片（可多选）">
            <file-upload
              :value="rejectImageUrls"
              type="image"
              :count="9"
              field-name="rejectImageUrls"
              @change="onRejectImagesChange"
            />
          </a-form-model-item>
        </a-form-model>
      </a-spin>
    </a-modal>

    <a-modal title="驳回话术管理" :visible="phraseManageVisible" width="760px" :footer="null" @cancel="phraseManageVisible = false">
      <div style="margin-bottom: 12px">
        <a-button type="primary" icon="plus" @click="openPhraseForm()">新增话术</a-button>
      </div>
      <a-table rowKey="id" size="small" :loading="phraseManageLoading" :columns="phraseColumns" :data-source="phraseManageList" :pagination="false">
        <span slot="status" slot-scope="text">
          <a-tag v-if="text === 1" color="green">启用</a-tag>
          <a-tag v-else>禁用</a-tag>
        </span>
        <span slot="phraseOp" slot-scope="text, record">
          <a @click="openPhraseForm(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确认删除该话术？" @confirm="removePhrase(record.id)">
            <a style="color: #ff4d4f">删除</a>
          </a-popconfirm>
        </span>
      </a-table>
    </a-modal>

    <a-modal
      :title="phraseForm.id ? '编辑话术' : '新增话术'"
      :visible="phraseFormVisible"
      :confirm-loading="phraseFormSubmitting"
      @ok="submitPhraseForm"
      @cancel="phraseFormVisible = false"
    >
      <a-form-model layout="vertical">
        <a-form-model-item label="标题" required>
          <a-input v-model="phraseForm.title" placeholder="如：银行卡信息有误" />
        </a-form-model-item>
        <a-form-model-item label="话术内容" required>
          <a-textarea v-model="phraseForm.content" rows="4" placeholder="发送给用户的驳回说明" />
        </a-form-model-item>
        <a-form-model-item label="排序">
          <a-input-number v-model="phraseForm.sort" :min="0" style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-radio-group v-model="phraseForm.status">
            <a-radio :value="1">启用</a-radio>
            <a-radio :value="0">禁用</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal title="确认线下打款" :visible="payOpen" @ok="submitPay" @cancel="payOpen = false">
      <template v-if="currentRecord">
        <a-alert type="info" show-icon style="margin-bottom: 16px">
          <template slot="message">
            请向以下账户打款 {{ currentRecord.actualAmount }}：
            {{ currentRecord.bankName }} / {{ currentRecord.accountName }} / {{ currentRecord.cardNo }}
            <a class="copy-link inline-copy" style="margin-left: 8px" @click="copyBankInfo(currentRecord, true)">
              <a-icon type="copy" /> 复制收款信息
            </a>
          </template>
        </a-alert>
      </template>
      <a-form-model :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="打款凭证">
          <file-upload v-model="paymentProofUrl" type="image" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import {
  pageWithdraw,
  getWithdrawDetail,
  auditWithdraw,
  claimWithdraw,
  listRejectPhrases,
  saveRejectPhrase,
  deleteRejectPhrase
} from '@/api/giftcard/redeem'
import { mapGetters } from 'vuex'

const BIZ_TYPE_WITHDRAW = 2
const LIST_POLL_MS = 5000

export default {
  name: 'GiftcardWithdraw',
  data() {
    return {
      loading: false,
      detailLoading: false,
      phraseLoading: false,
      rejectSubmitting: false,
      phraseManageLoading: false,
      phraseFormSubmitting: false,
      list: [],
      total: 0,
      listPollTimer: null,
      queryParam: { pageNum: 1, pageSize: 10, status: undefined },
      rejectOpen: false,
      payOpen: false,
      detailOpen: false,
      phraseManageVisible: false,
      phraseFormVisible: false,
      rejectReason: '',
      rejectImageUrls: '',
      selectedPhraseKey: 'custom',
      rejectPhrases: [],
      phraseManageList: [],
      phraseForm: {},
      paymentProofUrl: '',
      currentRecord: null,
      detail: null,
      columns: [
        { title: '提现单号', dataIndex: 'withdrawNo', width: 170 },
        { title: '用户ID', dataIndex: 'userId', width: 90 },
        { title: '收款银行信息', scopedSlots: { customRender: 'bankInfo' }, width: 220 },
        { title: '用户总额', dataIndex: 'userTotalAmount', scopedSlots: { customRender: 'userTotalAmount' }, width: 110, align: 'right' },
        { title: '钱包金额', dataIndex: 'walletBalanceBefore', scopedSlots: { customRender: 'walletBalanceBefore' }, width: 110, align: 'right' },
        { title: '本次提现', dataIndex: 'amount', scopedSlots: { customRender: 'amount' }, width: 120, align: 'right' },
        { title: '提现成功余额', dataIndex: 'balanceAfterWithdraw', scopedSlots: { customRender: 'balanceAfterWithdraw' }, width: 130, align: 'right' },
        { title: '手续费', dataIndex: 'feeAmount', scopedSlots: { customRender: 'feeAmount' }, width: 90, align: 'right' },
        { title: '实到', dataIndex: 'actualAmount', scopedSlots: { customRender: 'actualAmount' }, width: 90, align: 'right' },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, width: 90 },
        { title: '打款凭证', dataIndex: 'paymentProofUrl', scopedSlots: { customRender: 'paymentProofUrl' }, width: 90 },
        { title: '申请时间', dataIndex: 'createTime', width: 170 },
        { title: '操作', scopedSlots: { customRender: 'operation' }, width: 240, fixed: 'right' }
      ],
      phraseColumns: [
        { title: '标题', dataIndex: 'title', width: 120 },
        { title: '内容', dataIndex: 'content', ellipsis: true },
        { title: '排序', dataIndex: 'sort', width: 70 },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, width: 80 },
        { title: '操作', scopedSlots: { customRender: 'phraseOp' }, width: 120 }
      ]
    }
  },
  computed: {
    ...mapGetters(['auditWithdrawPending'])
  },
  created() {
    this.getList()
    this.startListPoll()
  },
  beforeDestroy() {
    this.stopListPoll()
  },
  watch: {
    selectedPhraseKey(key) {
      this.applySelectedPhrase(key)
    },
    auditWithdrawPending() {
      this.getList()
    }
  },
  methods: {
    startListPoll() {
      this.stopListPoll()
      this.listPollTimer = setInterval(() => {
        if (!this.loading && !this.rejectOpen && !this.detailOpen && !this.payOpen) {
          this.getList(true)
        }
      }, LIST_POLL_MS)
    },
    stopListPoll() {
      if (this.listPollTimer) {
        clearInterval(this.listPollTimer)
        this.listPollTimer = null
      }
    },
    formatMoney(val) {
      if (val == null || val === '') return '—'
      const num = Number(val)
      if (Number.isNaN(num)) return val
      return num.toFixed(2)
    },
    formatCopyAmount(val) {
      if (val == null || val === '') return '—'
      const num = Number(val)
      if (Number.isNaN(num)) return val
      return num.toFixed(2)
    },
    splitImageUrls(urls) {
      if (!urls) return []
      return String(urls).split(',').map(u => u.trim()).filter(Boolean)
    },
    onRejectImagesChange(val) {
      if (typeof val === 'string') {
        this.rejectImageUrls = val
      } else if (val && typeof val === 'object') {
        this.rejectImageUrls = val.rejectImageUrls || ''
      }
    },
    statusText(status) {
      const map = { 1: '待审核', 2: '处理中', 3: '已打款', 4: '驳回' }
      return map[status] || status
    },
    formatBankInfoText(record, withAmount = false) {
      const lines = [
        `银行：${record.bankName || '—'}`,
        `户名：${record.accountName || '—'}`,
        `卡号：${record.cardNo || '—'}`
      ]
      if (record.amount != null) {
        lines.push(`本次提现：${this.formatCopyAmount(record.amount)}`)
      }
      if (withAmount && record.actualAmount != null) {
        lines.push(`实到金额：${this.formatMoney(record.actualAmount)}`)
      }
      return lines.join('\n')
    },
    copyBankInfo(record, withAmount = false) {
      if (!record) return
      const text = this.formatBankInfoText(record, withAmount)
      this.$copyText(text).then(() => {
        this.$message.success('收款银行信息已复制')
      }).catch(() => {
        this.$message.error('复制失败，请手动复制')
      })
    },
    getList(silent) {
      if (!silent) {
        this.loading = true
      }
      return pageWithdraw(this.queryParam).then(res => {
        this.list = (res.data && res.data.records) || []
        this.total = (res.data && res.data.total) || 0
      }).finally(() => {
        if (!silent) {
          this.loading = false
        }
      })
    },
    /** 审核/打款/驳回后：关弹窗 + 刷列表 + 刷待办 */
    refreshAfterAudit() {
      this.detailOpen = false
      this.payOpen = false
      this.closeReject()
      this.$store.dispatch('auditReminder/fetchAuditPendingCount')
      return this.getList()
    },
    loadRejectPhrases() {
      this.phraseLoading = true
      return listRejectPhrases(BIZ_TYPE_WITHDRAW, false).then(res => {
        this.rejectPhrases = res.data || []
      }).finally(() => { this.phraseLoading = false })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    changePage(page, pageSize) {
      this.queryParam.pageNum = page
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    showDetail(record) {
      this.detailOpen = true
      this.detailLoading = true
      this.detail = null
      getWithdrawDetail(record.id).then(res => {
        this.detail = res.data
      }).finally(() => { this.detailLoading = false })
    },
    isProcessable(record) {
      return record && (record.status === 1 || record.status === 2)
    },
    needsClaim(record) {
      return record && record.status === 1 && !record.claimedByMe
    },
    canAuditActions(record) {
      return this.isProcessable(record) && !!record.claimedByMe
    },
    claimOrder(record) {
      claimWithdraw(record.id).then(() => {
        this.$message.success('接单成功')
        this.$store.dispatch('auditReminder/fetchAuditPendingCount')
        return this.getList()
      }).catch(() => {
        this.getList()
      })
    },
    audit(record, status) {
      const self = this
      this.$confirm({
        title: status === 2 ? '审核通过，进入线下打款流程？' : '确认操作？',
        content: `收款账户：${record.bankName || '—'} / ${record.accountName || '—'} / ${record.cardNo || '—'}`,
        onOk() {
          return auditWithdraw({ withdrawId: record.id, status }).then(() => {
            self.$message.success('操作成功')
            return self.refreshAfterAudit()
          })
        }
      })
    },
    showReject(record) {
      this.currentRecord = record
      this.rejectReason = ''
      this.rejectImageUrls = ''
      this.selectedPhraseKey = 'custom'
      this.rejectOpen = true
      this.loadRejectPhrases().then(() => {
        if (this.rejectPhrases.length) {
          this.selectedPhraseKey = 'p-' + this.rejectPhrases[0].id
        }
      })
    },
    closeReject() {
      this.rejectOpen = false
      this.rejectReason = ''
      this.rejectImageUrls = ''
      this.selectedPhraseKey = 'custom'
    },
    applySelectedPhrase(key) {
      if (!key || key === 'custom') {
        return
      }
      const id = String(key).replace(/^p-/, '')
      const item = this.rejectPhrases.find(p => String(p.id) === id)
      if (item) {
        this.rejectReason = item.content || ''
      }
    },
    submitReject() {
      const reason = (this.rejectReason || '').trim()
      if (!reason) {
        this.$message.warning('请填写驳回原因')
        return Promise.reject(new Error('empty reason'))
      }
      this.rejectSubmitting = true
      return auditWithdraw({
        withdrawId: this.currentRecord.id,
        status: 4,
        rejectReason: reason,
        rejectImageUrls: (this.rejectImageUrls || '').trim()
      }).then(() => {
        this.$message.success('已驳回并退回余额')
        return this.refreshAfterAudit()
      }).finally(() => { this.rejectSubmitting = false })
    },
    openPhraseManage() {
      this.phraseManageVisible = true
      this.loadPhraseManageList()
    },
    loadPhraseManageList() {
      this.phraseManageLoading = true
      listRejectPhrases(BIZ_TYPE_WITHDRAW, true).then(res => {
        this.phraseManageList = res.data || []
      }).finally(() => { this.phraseManageLoading = false })
    },
    openPhraseForm(record) {
      if (record) {
        this.phraseForm = { ...record }
      } else {
        this.phraseForm = { bizType: BIZ_TYPE_WITHDRAW, title: '', content: '', sort: 0, status: 1 }
      }
      this.phraseFormVisible = true
    },
    submitPhraseForm() {
      const form = this.phraseForm
      if (!(form.title || '').trim()) {
        this.$message.warning('请填写标题')
        return
      }
      if (!(form.content || '').trim()) {
        this.$message.warning('请填写话术内容')
        return
      }
      this.phraseFormSubmitting = true
      saveRejectPhrase({
        ...form,
        bizType: BIZ_TYPE_WITHDRAW,
        title: form.title.trim(),
        content: form.content.trim()
      }).then(() => {
        this.$message.success('保存成功')
        this.phraseFormVisible = false
        this.loadPhraseManageList()
      }).finally(() => { this.phraseFormSubmitting = false })
    },
    removePhrase(id) {
      deleteRejectPhrase(id).then(() => {
        this.$message.success('已删除')
        this.loadPhraseManageList()
      })
    },
    showPay(record) {
      this.currentRecord = record
      this.paymentProofUrl = record.paymentProofUrl || ''
      this.payOpen = true
    },
    submitPay() {
      return auditWithdraw({
        withdrawId: this.currentRecord.id,
        status: 3,
        paymentProofUrl: this.paymentProofUrl
      }).then(() => {
        this.$message.success('已标记打款完成')
        return this.refreshAfterAudit()
      })
    }
  }
}
</script>

<style scoped>
.sub-text {
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
}
.thumb-img {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 4px;
}
.thumb-img.clickable {
  cursor: pointer;
}
.img-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.phrase-radio {
  margin-bottom: 8px;
}
.copy-link {
  display: inline-block;
  margin-top: 4px;
  font-size: 12px;
  color: #1890ff;
  cursor: pointer;
}
.copy-link:hover {
  color: #40a9ff;
}
.inline-copy {
  margin-top: 0;
  margin-left: 8px;
}
.amount-cell {
  display: inline-block;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.amount-cell.total {
  color: #722ed1;
  font-size: 15px;
}
.amount-cell.wallet {
  color: #1890ff;
  font-size: 15px;
}
.amount-cell.withdraw {
  color: #fa541c;
  font-size: 18px;
  font-weight: 700;
}
.amount-cell.after {
  color: #52c41a;
  font-size: 16px;
  font-weight: 700;
}
.amount-cell.fee,
.amount-cell.actual {
  color: rgba(0, 0, 0, 0.75);
  font-size: 14px;
}
.claim-busy {
  color: #fa8c16;
  white-space: nowrap;
}
</style>

